import { PI_VERSION } from '../constants-types/constants';
import { InterviewGuideReminder } from '../core-data-model/InterviewGuideReminder.model';
import { JobStub } from '../core-data-model/Job/JobStub.model';
import { OiLink } from './OiLink.model';
import { OrderedSet } from './OrderedSet';

export class CompanySpecificSetting {
    companyId: string;
    recentlySelectedFolderIds: OrderedSet<string>;
    recentlySelectedGroupIds: OrderedSet<string>;
    recentlySelectedJobs: OrderedSet<JobStub>;

    constructor(obj?: any) {
        Object.assign(this, obj);
    }
}

export type ColumnSettings = {
    [propertyName: string]: boolean;
};

export type TableColumnSettings = {
    [tableId: string]: ColumnSettings;
};

export type OnboardingState = 'unstarted' | 'finished';

export type OnboardingAddUsersState = 'notDone' | 'skipped' | 'done';

// keep up to date with onboardingChecklistItems within NavigationMenu.component.ts
// takePITour property removed in 2019 sprint M -- Old users will still have this field
// may be worth running a DB cleanup script when moved over to DocDB
export type OnboardingChecklist = {
    [key: string]: boolean | OnboardingAddUsersState;
    initialLogin: boolean;
    connectBehavioral: boolean;
    inviteEmployeesBA: boolean;
    // type was boolean value before, new values should be 'notDone', 'skipped', or 'done'
    addMoreUsers: OnboardingAddUsersState;
    dropdownOpen: boolean;
};

export type OnboardingNextStepItemState = {
    [key: string]: boolean;
    personSnapshot: boolean;
    personalPlacard: boolean;
    pdc: boolean;
    relationshipGuide: boolean;
    teamPlacard: boolean;
    teamWorkstyles: boolean;
};

export type HireSpecificSettings = {
    showFullDescription?: boolean;
    showCognitiveNumericalScale?: boolean;
    firstTimeLoginDate?: Date;
};

export type AiAssistantUserSettings = {
    useNonPITechnicalTerms?: boolean;
};

export class UserProfileSetting {
    version: string = PI_VERSION;
    currentCompany: string;
    companySpecificSettings: OrderedSet<CompanySpecificSetting> =
        new OrderedSet<CompanySpecificSetting>([]);
    showCognitiveData = false;
    completedCardAdministeredByMe = false;
    pendingCardAdministeredByMe = false;
    jobCardModifiedByMe = false;
    preferredPageSize = 10;
    myOiLink: OiLink;
    tableColumnSettings: TableColumnSettings;
    reminders: InterviewGuideReminder[];
    interviewReminderLastShown: Date;
    hasAcknowledgedCogBestPractices = false;
    onboarding: OnboardingState = 'unstarted';
    firstLogin: Date;
    onboardingChecklist: OnboardingChecklist;
    onboardingNextSteps: OnboardingNextStepItemState;
    freemiumFirstCandidateViewed: boolean;
    hireSettings: HireSpecificSettings;
    hasAcknowledgedWelcomeGuideCta = false;
    aiAssistantUserSettings: AiAssistantUserSettings;

    firstLoginConstruction() {
        this.initOnboardingChecklist();
        this.firstLogin = new Date();
        this.onboardingChecklist.initialLogin = true;
    }

    initOnboardingChecklist() {
        if (!this.onboardingChecklist) {
            this.onboardingChecklist = {
                initialLogin: true,
                connectBehavioral: false,
                inviteEmployeesBA: false,
                addMoreUsers: 'notDone',
                dropdownOpen: true
            };
        }
    }
}
